<template>
  <div v-if="upgradeInfo" class="alert alert-success">
      <span v-if="canTransact">
        Upgade to gold today, for {{CurrencyFormatter(upgradeInfo.price)}}!
      </span>
      <span v-else>
        You need to pay your Gold Membership fee of {{CurrencyFormatter(upgradeInfo.price)}} before you can make a purchase.
      </span>
      <!-- If we will save more than upgrade cost show a message -->
      <div v-if="goldItemsTotal > 0 && memberItemsTotal > 0 && (memberItemsTotal - goldItemsTotal) > upgradeInfo.price">
        Wait! If you upgrade to gold before making this purchase you will save more than the cost of the upgrade.
      </div>
      <router-link
        :to="{name:'accountGoldUpgrade'}"
        class=" btn btn-upgrade"
      >{{upgradeText}}</router-link>
  </div>
</template>

<script>
import {fetchUpgradeInfo } from '@/network/userRequests';
import { CurrencyFormatter } from "@/utils";
import { mapState } from "vuex";

export default {
  name: 'UpgradeToGold',
  components: {
  },
  data(){
    return{
      loading: true,
      upgradeInfo: null,
    }
  },
  props: ["goldItemsTotal", "memberItemsTotal"],
  created(){
    this.getData();
  },
  methods:{
      CurrencyFormatter,

    getData(){
      this.loading = true;
      fetchUpgradeInfo().then(response =>{
          this.upgradeInfo = response;
          this.loading = false;
      }).catch(err =>{
          console.log("error getting upgrade price", err)
          this.loading = false;
      })
    },
  },
  computed: {
    ...mapState({
      canTransact: state => state.member.canTransact,
    }),
    upgradeText() {
      return (this.canTransact) ? 'Upgrade to Gold' : 'Pay Gold Fee';
    }
  }
}
</script>

<style lang="scss">

</style>
